class ProfileSecurityController {
    /* @ngInject */
  constructor($log, NewBackendService, StorageService) {
    const that = this;
    that.busy = false;
    that.checkRepeatPass = false;
    that.repeatPswError = false;
    that.securityObj = {
      oldCode: '',
      newCode: '',
      newCodeRepeat: ''
    };

    that.isCodeChanged = false;


    that.checkPassword = () => {
      const result = that.securityObj.newCode === that.securityObj.newCodeRepeat;
      that.checkRepeatPass = result;
      that.repeatPswError = !result;
      return result;
    };

    this.changeAccesCode = () => {
      const resetPwd = () => {
        that.securityObj.oldCode = '';
        that.securityObj.newCode = '';
        that.securityObj.newCodeRepeat = '';
      };

      const userName = StorageService.getLocalStorageObject('userContext');
      const data = {
        userContext: {},
        data: {
          request: {
            changePasswordRequest: {
              phoneNumber: userName.userId,
              newPassword: that.securityObj.newCode,
              oldPassword: that.securityObj.oldCode
            }
          }
        }
      };
      that.busy = true;
      // FoundationApi.publish('changecode-notifications', { title: 'Conferma', content: 'Codice di accesso cambiato correttamente' });
      NewBackendService.invokeWebApiPost('security/changePassword', data).then(result => {
        resetPwd();
        $log.debug('ho cambiato password', result);
        that.isCodeChanged = true;
      }, (error) => {
        resetPwd();
        $log.error('fallito cambio password');
        $log.error(error);
      }).finally(() => {
        that.busy = false;
      });
    };

  //  that.$onInit = init;
  }
}

export default ProfileSecurityController;



/** WEBPACK FOOTER **
 ** ./client/app/components/profile/security/security.controller.js
 **/